module.exports = __webpack_public_path__ + "img/moveone.37018cbf.png";